// extracted by mini-css-extract-plugin
export default {"header":"NotFound_header__N76Od","logo":"NotFound_logo__EOmQA","space":"NotFound_space__W02D+","h1":"NotFound_h1__KG-3P","message":"NotFound_message__OjmM-"};